/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_CheckboxesInputs */

const en_admin_questionnaire_editor_checkboxes = /** @type {(inputs: Admin_Questionnaire_Editor_CheckboxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checkboxes`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_CheckboxesInputs) => LocalizedString} */
const de_admin_questionnaire_editor_checkboxes = en_admin_questionnaire_editor_checkboxes;

/** @type {(inputs: Admin_Questionnaire_Editor_CheckboxesInputs) => LocalizedString} */
const es_admin_questionnaire_editor_checkboxes = en_admin_questionnaire_editor_checkboxes;

/** @type {(inputs: Admin_Questionnaire_Editor_CheckboxesInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_checkboxes = en_admin_questionnaire_editor_checkboxes;

/** @type {(inputs: Admin_Questionnaire_Editor_CheckboxesInputs) => LocalizedString} */
const it_admin_questionnaire_editor_checkboxes = en_admin_questionnaire_editor_checkboxes;

/** @type {(inputs: Admin_Questionnaire_Editor_CheckboxesInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_checkboxes = en_admin_questionnaire_editor_checkboxes;

/** @type {(inputs: Admin_Questionnaire_Editor_CheckboxesInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_checkboxes = en_admin_questionnaire_editor_checkboxes;

/** @type {(inputs: Admin_Questionnaire_Editor_CheckboxesInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_checkboxes = en_admin_questionnaire_editor_checkboxes;

/** @type {(inputs: Admin_Questionnaire_Editor_CheckboxesInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_checkboxes = en_admin_questionnaire_editor_checkboxes;

/**
* | output |
* | --- |
* | "Checkboxes" |
*
* @param {Admin_Questionnaire_Editor_CheckboxesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_checkboxes = /** @type {((inputs?: Admin_Questionnaire_Editor_CheckboxesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_CheckboxesInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_checkboxes(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_checkboxes(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_checkboxes(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_checkboxes(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_checkboxes(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_checkboxes(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_checkboxes(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_checkboxes(inputs)
	return ro_admin_questionnaire_editor_checkboxes(inputs)
});
export { admin_questionnaire_editor_checkboxes as "admin.questionnaire_editor.checkboxes" }